import { Box, Button, Text } from "@mantine/core";
import { useEffect, useId, useRef, useState } from "react";

import { useTranslation } from "~/hooks/use-typed-translation";

export function ExpandableBiography({ text }: { text?: string }) {
  const { t } = useTranslation();
  const id = useId();
  const ref = useRef<HTMLParagraphElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => {
    setExpanded(false);
    const element = ref.current;
    if (!element) return;
    const measure = () => {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      setOverflows(element.scrollHeight > lineHeight * 3 + 1);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);

  if (!text) return null;
  return (
    <Box mt="md" maw="70ch" mx="auto" ta="center">
      <Text ref={ref} id={id} c="dimmed" fz={14} lh={1.5} ta="center"
        lineClamp={expanded ? undefined : 3}>
        {text}
      </Text>
      {overflows && (
        <Box mt={4}>
          <Button type="button" variant="transparent" color="gray" size="compact-sm" px={0}
            aria-expanded={expanded} aria-controls={id}
            onClick={() => setExpanded(value => !value)}>
            {expanded ? t("profile-show-less") : t("profile-read-more")}
          </Button>
        </Box>
      )}
    </Box>
  );
}
